import useModalDisplay from "hooks/useDisplayModal";
import ConfirmPopup from 'components/modals/ConfirmPopup';
import { forwardRef } from 'react';
import useAccount from "hooks/useAccount";

const UnLinkToRHPAccountLink = forwardRef((props, ref) => {
    const {open, handleOpen, handleClose} = useModalDisplay();
    const { rhpLinkAcc, unLinkFromRHPAccount } = useAccount();

    const onConfirmed = (e) => {
        e && e.preventDefault && e.preventDefault();
        if (unLinkFromRHPAccount.isLoading) return;

        unLinkFromRHPAccount.mutateAsync()
            .then(() => handleClose())
            .catch(() => {}); // error handled by onError in useAccount
    };
    const {children} = props;
    return (
        <>
            <a 
                ref={ref}
                href="/"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpen();
                    }}
                   
                    >
                    {children}
                </a>
              
             {
                open
                &&
                <ConfirmPopup 
                    open={open} 
                    close={handleClose}
                    confirm={onConfirmed} 
                    heading="UnLink RHP Account" 
                    btnText="UnLink RHP Account">
                    <p>Are you sure you want to unlink from this rhp account : {rhpLinkAcc?.Username}?</p>
                </ConfirmPopup>
            }
        </>
    )
});

export default UnLinkToRHPAccountLink;